import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, message } from "antd";

import {
  updateDockerList,
  updateFolderPath,
} from "../../features/cloud/cloudSlice";
import { getDockerFileList } from "../../server/GoogleDrive";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { clearGoogleDriveState } from "../../utility/common/session-store";
import { useTranslation } from "react-i18next";
import LoadingModal from "../LoadingModal";

const DockerCreateFolder = () => {
  const { t } = useTranslation();
  const [folderName, setFolderName] = useState<string>("");
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [creating, setCreating] = useState<boolean>(false);
  const userState = useAppSelector((state: any) => state.user);
  const selectedDocker = useAppSelector(
    (state: any) => state.cloud.selectedDocker
  );
  const folderPath = useAppSelector((state: any) => state.cloud.folderPath);

  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const createDockerFolder = async () => {
    setCreating(true);
    try {
      // 1️⃣ Step 1: Create the new folder
      await getDockerFileList({
        command: 5,
        new_file_name: "",
        folder: folderPath, // current working directory
        new_folder: folderName, // name of folder to create
        search_keyword: "",
        file: "",
        instance_id: selectedDocker.instance_id,
        host_id: selectedDocker.host_id,
        user_id: userState.user_id,
      });

      // 2️⃣ Step 2: Refresh file list for the current working directory
      const refreshRes = await getDockerFileList({
        command: 9,
        new_file_name: "",
        search_keyword: "",
        folder: folderPath,
        file: "",
        instance_id: selectedDocker.instance_id,
        host_id: selectedDocker.host_id,
        user_id: userState.user_id,
      });

      // 3️⃣ Step 3: Update UI and state
      dispatch(updateDockerList(refreshRes.data.ops_result));
      setFolderName("");
      createFolderSuccess();
    } catch (err) {
      console.error("createDockerFolder error:", err);
      setFolderName("");
      createFolderFailed();
      clearGoogleDriveState();
      dispatch(updateFolderPath(""));
      navigate("/cloud");
    } finally {
      setCreating(false);
    }
  };

  const treatFolderName = (name: string) => {
    let treatedName = name.replace(/[&\/\\#,+()$~%.'":;*?<>{}]/g, "_");
    setFolderName(treatedName);
  };

  const closeFolderModal = () => {
    setCreateModal(false);
    setFolderName("");
  };

  const createFolderSuccess = () => {
    messageApi.success(t("Create Folder Success!"), 2.5);
    setCreateModal(false);
  };

  const createFolderFailed = () => {
    messageApi.error(t("Create Folder Failed!"), 2.5);
    setCreateModal(false);
  };

  return (
    <>
      {contextHolder}
      {creating && <LoadingModal />}
      <Button type="default" onClick={() => setCreateModal(true)}>
        {t("Create Folder")}
      </Button>
      <Modal
        open={createModal}
        title={t("Create Folder")}
        cancelText={t("cancel")}
        okText={t("Create Folder")}
        onCancel={() => closeFolderModal()}
        onOk={() => createDockerFolder()}
        okButtonProps={{ disabled: folderName === "" ? true : false }}
        centered
      >
        <span>{t("New Folder Name")}: &nbsp;</span>
        <input
          id="file-upload"
          type="text"
          value={folderName}
          onChange={(e) => treatFolderName(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default DockerCreateFolder;
